<template>
<div class="cfd-list">
    <template v-for="column in columnsToShow">
        <InstrumentsListItemDataItem v-if="!hasSubcolumns(column)" :instrument="instrument" :column="column" :key="column.MatchingFieldName"/>
        <InstrumentsListItemDataItem v-else v-for="subcolumn in column.SubColumns" :instrument="instrument" :column="subcolumn" :key="subcolumn.MatchingFieldName"/>
    </template>
</div>
</template>

<script>
import InstrumentsListItemDataItem from './InstrumentsListItemDataItem.vue';

export default {
    name: 'InstrumentsListItemData',

    components: {
        InstrumentsListItemDataItem
    },

    props: {
        instrument: {
            type: Object,
            required: true
        }
    },

    computed: {
        columnsToShow () {
            return this.$store.state.columnsToShow;
        }
    },

    methods: {
        hasSubcolumns (column) {
            return column.SubColumns.length;
        }
    }
};
</script>

<style scoped>
.cfd-list {
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/InstrumentsListItemData.vue